<template>
  <div class="summary-accounts" data-testid="task-summary-accounts">
    <div class="summary-accounts__header" data-testid="task-summary-accounts__title">
      Accounts
    </div>

    <div class="summary-accounts__content">
      <div class="summary-accounts__list" data-testid="task-summary-accounts__list">
        <div
          v-if="!accounts.length"
          class="summary-accounts__empty"
          data-testid="task-summary-accounts__empty"
        >
          No linked accounts
        </div>

        <div
          v-for="(gl, index) in accounts"
          :key="gl._id || gl.glcode || index"
          class="summary-accounts__row"
          :data-testid="`task-summary-accounts__row-${index}`"
        >
          <span class="summary-accounts__glcode">{{ gl.glcode }}</span>
          <span class="summary-accounts__separator" aria-hidden="true">·</span>
          <div class="summary-accounts__identity">
            <span class="summary-accounts__name">{{ gl.name }}</span>
            <v-chip
              v-if="showLocationBadge(gl)"
              class="summary-accounts__location-chip"
              :data-testid="`task-summary-accounts__location-chip-${index}`"
            >
              {{ accountLocationName(gl) }}
            </v-chip>
          </div>
          <span class="summary-accounts__amount">{{ formatAmount(gl.closing_amount) }}</span>
        </div>
      </div>

      <div class="summary-accounts__footer">
        <button
          type="button"
          class="summary-accounts__view-link"
          data-testid="task-summary-accounts__view-btn"
          @click="drawerOpen = true"
        >
          View
        </button>
      </div>
    </div>

    <TaskSummaryAccountsDrawer
      v-model="drawerOpen"
      :accounts="accounts"
    />
  </div>
</template>

<script>
import TaskSummaryAccountsDrawer from '../../modals/TaskSummaryAccountsDrawer.vue';
import {
  buildLocationTypeById,
  isConsolidatedLocationId,
} from '@/modules/financialclose/utils/locationMasterType';
import { tbLocationDisplayName } from '@/modules/financialclose/utils/tbGlLocationValidation';
import './TaskSummaryAccounts.scss';

export default {
  name: 'TaskSummaryAccounts',

  components: {
    TaskSummaryAccountsDrawer,
  },

  props: {
    task: { type: Object, required: true },
  },

  data() {
    return {
      drawerOpen: false,
    };
  },

  computed: {
    accounts() {
      const items = this.task?.__tbtotals?.items;
      return Array.isArray(items) ? items : [];
    },
    isConsolidatedLocationSelected() {
      const form = this.$store.getters['tasks/getFormDataV3'] || {};
      const locationMap = this.$store.getters['tasks/getLocationMap'] || {};
      const locations = [
        ...Object.values(locationMap),
        ...(form.locations || []),
        ...(form.actorLocations || []),
      ];
      return isConsolidatedLocationId(
        this.task?.location,
        buildLocationTypeById(locations)
      );
    },
  },

  methods: {
    accountLocationName(gl) {
      return tbLocationDisplayName(gl);
    },
    showLocationBadge(gl) {
      return this.isConsolidatedLocationSelected && !!this.accountLocationName(gl);
    },
    formatAmount(val) {
      const n = Number(val);
      if (Number.isNaN(n)) return '—';
      const formatted = Math.abs(n).toLocaleString('en-US', { maximumFractionDigits: 0 });
      if (n < 0) return `($${formatted})`;
      return `$${formatted}`;
    },
  },
};
</script>
